<template>
  <div>
    <wc-page-title title='General Settings'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <misc></misc>
        </v-col>
        <v-col cols='12' md='8'>
          <driveway-ratings></driveway-ratings>
        </v-col>
        <v-col cols='12'>
          <lawn-ratings></lawn-ratings>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DrivewayRatings from './DrivewayRatings'
import LawnRatings from './LawnRatings'
import Misc from './Misc'

export default {
  name: 'settings',
  components: {
    'misc': Misc,
    'driveway-ratings': DrivewayRatings,
    'lawn-ratings': LawnRatings
  }
}
</script>
